module.exports = __webpack_public_path__ + "img/eh.cd96c409.svg";